import React from 'react'
import { Button, Card, CardHeader, Col, Row } from 'reactstrap';
import NumberFormat from 'react-number-format';

const SelectBankListItem = ({
    title,
    alternativeName,
    id,
    onSelect,
    selected,
    createdAt,
    account,
    owner_name,
    owner_dni,
}) => {

    const jsUcfirst = (string) => { return string.charAt(0).toUpperCase() + string.slice(1); }

    const getDate = (date) => { var d = new Date(date); return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;}

    return (
        <Card className="shadow-none border-top" data-testid="CondominiumItem">
            <Button color={`falcon-default`} className="border-none shadow-none text-left p-0" onClick={onSelect}>
                <CardHeader className={selected ? selected === id ? 'bg-secondary' : '' : ''} style={{ background: 'none' }} >
                    <Row>
                        <Col xs={6} className="d-flex align-items-center">
                            <div className='m-0'>
                                <h6 className='m-0'>{title}</h6>
                                {createdAt && <p className='mb-0'>
                                    {jsUcfirst(alternativeName)} creado el <span data-testid="date" >{getDate(createdAt)}</span>
                                </p>}
                            </div>
                        </Col>
                        <Col xs={6} className="d-flex align-items-center border-left">
                            <div className="media-body">
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">Titular</span>
                                </h6>
                                <p className="m-0">{owner_name}</p>
                            </div>
                        </Col>
                        <Col xs={6} className="d-flex align-items-center">
                            <div className="media-body">
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">DNI</span>
                                </h6>
                                <p className="m-0">{owner_dni}</p>
                            </div>
                        </Col>
                        <Col xs={6} className="d-flex align-items-center border-left">
                            <div className="media-body">
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">Número de cuenta</span>
                                </h6>
                                <p className="m-0"><NumberFormat thousandSeparator={true} displayType="text" format="#### #### #### #### #### ####" value={account} /></p>
                            </div>
                        </Col>
                    </Row>
                </CardHeader>
            </Button>
        </Card>
    )
}


export default SelectBankListItem;